import { MONTHS_FULL, WEEKDAYS } from "../../constants/data";
import { IconSearch, IconTrend } from "../icons/Icons";

export default function MonthView({ year, month, onMonthChange, allEvents, vehicles, projectColorMap = {}, onSelectVehicle }) {
  const firstDay    = new Date(year, month, 1);
  const startOffset = (firstDay.getDay() + 6) % 7;       // Monday-based
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const monthEvents = allEvents.filter(e => e.col === month + 1);

  // Build calendar cells
  const cells = [];
  for (let i = 0; i < startOffset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);

  const weeks = [];
  for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));

  return (
    <div style={{ flex: 1, padding: 12, display: "flex", flexDirection: "column", gap: 10, overflowY: "auto" }}>
      {/* Toolbar */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <button style={{ background: "none", border: "none", cursor: "pointer", color: "#555", display: "flex", alignItems: "center" }}>
            <IconSearch />
          </button>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <button onClick={() => onMonthChange(-1)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: "#555", padding: "3px 8px", borderRadius: 4 }}>‹</button>
          <div style={{ fontSize: 18, fontWeight: 500, display: "flex", alignItems: "center", gap: 7 }}>
            {MONTHS_FULL[month]} {year} <IconTrend />
          </div>
          <button onClick={() => onMonthChange(1)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: "#555", padding: "3px 8px", borderRadius: 4 }}>›</button>
        </div>
      </div>

      {/* Calendar grid */}
      <div style={{ background: "white", borderRadius: 6, overflow: "hidden", border: "1px solid #dde3e8" }}>
        {/* Day-of-week header */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", background: "#1e6b6b" }}>
          {WEEKDAYS.map(d => (
            <div key={d} style={{ color: "white", fontSize: 12, fontWeight: 600, textAlign: "center", padding: "8px 0" }}>{d}</div>
          ))}
        </div>

        {/* Weeks */}
        {weeks.map((week, wi) => (
          <div key={wi} style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", borderTop: "1px solid #dde3e8" }}>
            {week.map((day, di) => {
              const eventsOnDay = day ? monthEvents.filter(e => e.row === day) : [];
              const isToday     = day && year === 2026 && month === 2 && day === 18;

              return (
                <div
                  key={di}
                  style={{
                    minHeight: 72, padding: 6,
                    borderRight: di < 6 ? "1px solid #dde3e8" : "none",
                    background: !day ? "#f9fafb" : wi % 2 === 0 ? "white" : "#f4f8f8",
                  }}
                >
                  {day && (
                    <div style={{
                      width: 22, height: 22, borderRadius: "50%",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      fontSize: 12, fontWeight: 600, marginBottom: 4,
                      background: isToday ? "#1e6b6b" : "transparent",
                      color: isToday ? "white" : (di >= 5 ? "#aaa" : "#333"),
                    }}>
                      {day}
                    </div>
                  )}                  {eventsOnDay.map((ev, ei) => {
                      const bg    = projectColorMap[ev._projektname] || "#cce5ff";
                      const color = "#1a1a2e";
                      return (
                        <div
                          key={ei}
                          onClick={() => {
                            const v = vehicles.find(v => v.id === ev._vehicleId);
                            if (v) onSelectVehicle(v);
                          }}
                          title={ev._projektname || ev.label}
                          style={{
                            display: "flex", alignItems: "center", gap: 3, borderRadius: 3,
                            padding: "2px 5px", fontSize: 10, fontWeight: 600, whiteSpace: "nowrap",
                            marginBottom: 2, cursor: ev._vehicleId ? "pointer" : "default",
                            background: bg, color,
                          }}
                        >
                          <span style={{ width: 6, height: 6, borderRadius: "50%", background: color, opacity: 0.45, flexShrink: 0 }} />
                          {ev.label}
                        </div>
                      );
                    })}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}
